import * as React from "react";
import { Affix } from "../affix/affix.mjs";
import { Button } from "../button/button.mjs";
import { Container } from "../container/container.mjs";
import { Grid } from "../grid/grid/grid.mjs";
import { GridColumn } from "../grid/grid-column/grid-column.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import "debounce";
import "tabbable";
import { useCurrentBreakPoint } from "../helpers/helper/hooks/use-current-breakpoint.mjs";
import { Separator } from "../separator/separator.mjs";
import { Table } from "../table/table/table.mjs";
import { PacketsTableHeader } from "./packets-table-header.mjs";
import { TvComparisonContext } from "./tv-comparison.mjs";
const ScrollTable = (props) => {
  const { packets, isFirstTable, children, title, headingLevel, count, identifier } = props;
  const { scrollLeftButton, scrollRightButton } = React.useContext(TvComparisonContext);
  const [scrollLeft, setScrollLeft] = React.useState(0);
  const [headerRef, setHeaderRef] = React.useState(null);
  const [contentRef, setContentRef] = React.useState(null);
  const currentBreak = useCurrentBreakPoint();
  const scrollListener = (e) => {
    setScrollLeft(e.currentTarget.scrollLeft);
  };
  const canScrollRight = () => {
    var _a, _b;
    const scrollWidth = (_a = contentRef == null ? void 0 : contentRef.scrollWidth) != null ? _a : 0;
    const clientWidth = (_b = contentRef == null ? void 0 : contentRef.clientWidth) != null ? _b : 0;
    return scrollWidth - clientWidth >= scrollLeft + 1;
  };
  const canScrollLeft = () => scrollLeft > 1;
  const handleScrollRightClick = (event) => {
    var _a;
    if (contentRef) {
      contentRef.scrollBy(60, 0);
      setScrollLeft(scrollLeft + 60);
    }
    (_a = scrollRightButton == null ? void 0 : scrollRightButton.onClick) == null ? void 0 : _a.call(scrollRightButton, event);
  };
  const handleScrollLeftClick = (event) => {
    var _a;
    if (contentRef) {
      contentRef.scrollBy(-60, 0);
      setScrollLeft(scrollLeft - 60);
    }
    (_a = scrollLeftButton == null ? void 0 : scrollLeftButton.onClick) == null ? void 0 : _a.call(scrollLeftButton, event);
  };
  React.useEffect(() => {
    if (headerRef) {
      headerRef.scrollLeft = scrollLeft;
    }
  }, [headerRef, scrollLeft, packets.length]);
  return /* @__PURE__ */ React.createElement("div", { className: "text-small" }, !isFirstTable && /* @__PURE__ */ React.createElement(Separator, { spacing: currentBreak === "xs" ? "medium" : "small", color: "invisible" }), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Grid, { align: ["between-xs"], verticalGutter: "small" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min-xs"] }, /* @__PURE__ */ React.createElement(Heading, { id: "scroll-table-title-heading-".concat(identifier), level: headingLevel, className: "h4" }, title, count && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("span", { className: "text-light" }, "(", count, ")")))), /* @__PURE__ */ React.createElement(GridColumn, { width: ["min-xs"] }, (canScrollLeft() || canScrollRight()) && /* @__PURE__ */ React.createElement(Grid, { align: ["end-xs"], noWrap: true, gutter: "small", className: "hidden-sm" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min-xs"] }, scrollLeftButton && /* @__PURE__ */ React.createElement(
    Button,
    {
      ...scrollLeftButton,
      id: "scroll-table-left-button-".concat(identifier),
      size: "small",
      icon: "#arrow-left",
      tabIndex: -1,
      disabled: !canScrollLeft(),
      onClick: handleScrollLeftClick
    }
  )), /* @__PURE__ */ React.createElement(GridColumn, { width: ["min-xs"] }, scrollRightButton && /* @__PURE__ */ React.createElement(
    Button,
    {
      ...scrollRightButton,
      id: "scroll-table-right-button-".concat(identifier),
      size: "small",
      icon: "#arrow-right",
      tabIndex: -1,
      disabled: !canScrollRight(),
      onClick: handleScrollRightClick
    }
  )))))), /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), /* @__PURE__ */ React.createElement(Affix, null, /* @__PURE__ */ React.createElement("div", { className: "tv-comparison__scroll-header" }, /* @__PURE__ */ React.createElement(Table, { elementRef: setHeaderRef, bordered: true }, /* @__PURE__ */ React.createElement(PacketsTableHeader, { packets })))), /* @__PURE__ */ React.createElement("div", { className: "tv-comparison__scroll-body" }, /* @__PURE__ */ React.createElement(
    Table,
    {
      bordered: currentBreak === "xs",
      "aria-labelledby": "scroll-table-title-heading-".concat(identifier),
      elementRef: setContentRef,
      onScroll: scrollListener
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, children)
  )));
};
export {
  ScrollTable
};
